import { render, staticRenderFns } from "./CustomerTagTranslationEditPopup.vue?vue&type=template&id=401f0862&"
import script from "./CustomerTagTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerTagTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports